import { useNavigate, useSearchParams } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNafathStatus, nafathVerification } from '../../store/actions/accountOpeningAction';
import { setAccountOpening, setApplicationId } from '../../store/slices/contentSlice';
import { getContentKeyAccToLang, setToken } from '../../utils/utils';
import { logoutUser } from '../../store/actions/authActions';

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()

  const { TextWeight, isArabic } = dynamicfunction();

  const user = useSelector((state) => state.content?.user);
  const applicationId = useSelector((state) => state.content?.applicationId);
  const nafath_loading = useSelector((state) => state.accountOpening?.nafath_loading);
  const corpAOContent = useSelector((state) => state.content?.corpAOContent);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(corpAOContent?.web_nafath_varification?.data?.attributes, key, isArabic);
  };

  const handleLogout = () => {
    // if (!user) {
    //   dispatch(setAccountOpening(null))
    //   dispatch(setApplicationId(null))
    //   setToken("")
    //   navigate("/login")
    // } else {
    //   dispatch(logoutUser(null, isArabic))
    // }

    window.location.href = `${process.env.REACT_APP_OPEN_ACCOUNT_LINK}${isArabic ? 'ar' : 'en'}`;
  };

  const [searchParams, setSearchParams] = useSearchParams();

  const [iqamaNo, setIqamaNo] = useState('');

  useEffect(() => {
    const status = searchParams.get('status');
    const request_id = searchParams.get('requestId');

    if (request_id && status?.toLowerCase() === 'success') {
      dispatch(getNafathStatus(request_id, (res) => {
        if (res?.result?.verified) navigate("/corporate-form?step=1", { replace: true })
      }))
    }

  }, [searchParams])

  const handleNafathVerification = () => {

    const api_data = {
      corpClientApplicationId: applicationId,
      nationalId: iqamaNo,
      returnUrl: window.location.origin + process.env.PUBLIC_URL + '/#/nafath-verification',
      local: isArabic ? 'ar' : 'en',
    }

    dispatch(nafathVerification(api_data, (res) => {
      window.location.href = res?.result?.redirectUrl;
    }))
  }

  return { TextWeight, navigate, iqamaNo, setIqamaNo, handleNafathVerification, nafath_loading, handleLogout, getContentKey };
};
